import { render, staticRenderFns } from "./ShelfBadge.vue?vue&type=template&id=472c8a2a&scoped=true&"
import script from "./ShelfBadge.vue?vue&type=script&lang=js&"
export * from "./ShelfBadge.vue?vue&type=script&lang=js&"
import style0 from "./ShelfBadge.vue?vue&type=style&index=0&id=472c8a2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472c8a2a",
  null
  
)

export default component.exports